import React from "react";
import { RouteComponentProps, Router } from "@reach/router";
import { OnboardingIntro } from "./OnboardingIntro/OnboardingIntro";
import { OnboardingQuestion } from "./OnboardingQuestion/OnboardingQuestion";
import { OnboardingSuccess } from "./OnboardingSuccess/OnboardingSuccess";
import { OnboardingBrandsQuery } from "./OnboardingBrands/OnboardingBrandsQuery";
import { OnboardingGoal } from "./OnboardingGoal/OnboardingGoal";

// == Types ================================================================

// == Constants ============================================================

// == Component ============================================================

export function OnboardingRouter(_props: RouteComponentProps) {
  return (
    <Router>
      <OnboardingIntro path="intro" />
      <OnboardingSuccess path="success" />
      <OnboardingBrandsQuery path="brands" />
      <OnboardingGoal path="goal" />
      <OnboardingQuestion path="questions/:id" />
    </Router>
  );
}

// == Styles ===============================================================
